/** Display helpers. */

export function compact(value: number): string {
  if (!Number.isFinite(value)) return '-'
  if (Math.abs(value) < 1000) return String(value)
  return new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(
    value,
  )
}

export function thousands(value: number): string {
  return new Intl.NumberFormat('en').format(value)
}

export function percent(value: number, digits = 0): string {
  return `${(value * 100).toFixed(digits)}%`
}

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return 'never'
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return '-'

  const seconds = Math.round((Date.now() - then) / 1000)
  if (seconds < 60) return 'just now'

  const units: Array<[Intl.RelativeTimeFormatUnit, number]> = [
    ['minute', 60],
    ['hour', 3600],
    ['day', 86400],
    ['week', 604800],
    ['month', 2629800],
    ['year', 31557600],
  ]

  const formatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })
  let chosen: [Intl.RelativeTimeFormatUnit, number] = units[0]
  for (const unit of units) {
    if (Math.abs(seconds) >= unit[1]) chosen = unit
  }
  return formatter.format(-Math.round(seconds / chosen[1]), chosen[0])
}

export function dateTime(iso: string | null | undefined): string {
  if (!iso) return '-'
  return new Date(iso).toLocaleString('en', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function timeOnly(iso: string): string {
  return new Date(iso).toLocaleTimeString('en', { hour: '2-digit', minute: '2-digit' })
}

export function dayLabel(iso: string): string {
  return new Date(iso).toLocaleDateString('en', { day: 'numeric', month: 'short' })
}

const TITLES: Record<string, string> = {
  customer_provider: 'Customer / provider',
  buyer_seller: 'Buyer / seller',
  referral_business: 'Referral',
  partner_partner: 'Partnership',
  employer_candidate: 'Employer / candidate',
  investor_founder: 'Investor / founder',
  mentor_learner: 'Mentor / learner',
  supplier_business: 'Supplier',
  connector_opportunity: 'Connector',
}

export function matchTypeLabel(value: string): string {
  return TITLES[value] ?? sentence(value)
}

export function sentence(value: string): string {
  const text = value.replace(/_/g, ' ').trim()
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
